/**
 * A hand-picked selection of Bilspektrum's Google reviews, plus the real overall rating.
 * Refreshed by hand with the `google-reviews` skill (no Places API). The section always
 * says it is a selection and links to all reviews on Google (Konsumentverket's rules on reviews).
 */

export type GoogleReview = {
  /** First name + last initial, as we show it on the site. */
  name: string;
  rating: 1 | 2 | 3 | 4 | 5;
  /** Exact text from Google; never edit the wording. */
  text: string;
  /** Roughly when it was written (Google only shows "för 3 månader sedan"). */
  date: string;
  topic: "sales" | "workshop" | "general";
};

/** Google place ID for Bilspektrum AB, Formvägen 10 A (derived from the Maps feature ID). */
const PLACE_ID = "ChIJs-vepn1bfEYRED9i9RauHv4";
const CID = "18311264548564385552";

export const GOOGLE_REVIEWS = {
  rating: 4.3,
  count: 189,
  /** When rating, count and the selection were last checked on Google. */
  checked: "2026-10-08",
  writeReviewUrl: `https://search.google.com/local/writereview?placeid=${PLACE_ID}`,
  allReviewsUrl: `https://www.google.com/maps?cid=${CID}`,
  reviews: [
    {
      name: "Mike H.",
      rating: 5,
      date: "2025-10",
      topic: "sales",
      text: "Vi var på jakt efter en bil och fick hjälp av Erik Mikaels. Riktig professionell hjälp och driven försäljare. Engagerad och mycket trevlig försäljare. Rekommenderas varmt!",
    },
    {
      name: "R.J.",
      rating: 5,
      date: "2026-03",
      topic: "workshop",
      text: "Seriös och kunnig personal på verkstaden, kunde hitta och lösa ett bilfel som tidigare verkstad misslyckas på två besök. Trots inga tydliga felmeddelanden i logg, utan endast min felbeskrivning.",
    },
    {
      name: "Sofia A.",
      rating: 5,
      date: "2026-06",
      topic: "workshop",
      text: "Sjukt fin personal på verkstaden hos Bilspektrum! Och arbetet blir alltid gjort.",
    },
    {
      name: "Niklas S.",
      rating: 5,
      date: "2026-07",
      topic: "general",
      text: "Verkligen fint och bra bemötande från personal som verkligen vill hjälpa till.",
    },
    {
      name: "Joel F.",
      rating: 5,
      date: "2026-08",
      topic: "general",
      text: "Bra bemötande och flexibla!",
    },
    {
      name: "Oleksiy H.",
      rating: 5,
      date: "2026-07",
      topic: "general",
      text: "Utmärkt vänlig och effektiv service.",
    },
  ] satisfies GoogleReview[],
};
